import { PROCESS_STEPS } from "../../lib/site";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-brand-eucalyptus text-brand-cream relative overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="label-eyebrow text-brand-cream/70 mb-5">How it works</div>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-medium">
              A calm, considered path to settlement.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-base md:text-lg text-brand-cream/75 leading-relaxed">
              Four simple steps. No jargon, no surprises — just clear
              communication from day one to keys in hand.
            </p>
          </div>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS_STEPS.map((step) => (
            <li
              key={step.n}
              data-testid={`process-step-${step.n}`}
              className="relative rounded-2xl border border-brand-cream/15 p-6 lg:p-8 bg-brand-eucalyptusDark/40 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:bg-brand-eucalyptusDark/70"
            >
              <div className="font-display text-5xl tracking-tighter text-brand-cream/30">
                {step.n}
              </div>
              <h3 className="mt-6 font-display text-2xl tracking-tight">
                {step.title}
              </h3>
              <p className="mt-3 text-sm text-brand-cream/75 leading-relaxed">
                {step.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
